<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2024-05-07 09:14:16
 * @LastEditors: whaoo
 * @LastEditTime: 2024-05-07 10:25:02
-->
<template>
  <div class="layout">
    <div class="layout_left">
      <div class="logo_box" @dblclick="logout">
        <img src="../../assets/sidebar_logo.png" alt />
      </div>
      <Sidebar></Sidebar>
    </div>
    <div class="layout_right">
      <HeaderTop class="header_top"></HeaderTop>
      <AppMain class="app_main"></AppMain>
    </div>

    <el-dialog ref="cusTomDialog" title="退出登录" width="580px" :visible.sync="dialogVisible"  top="28vh">
      <div class="dialog-body">
         <div class="tip">请输入管理员密码，获取该功能权限</div>
        <password-input
          v-model="password"
          :length="6"
          @success="passwordCheck"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import passwordInput from "../../../src/view/managePages/components/passwordInput.vue";
import Sidebar from "./sidebar.vue";
import HeaderTop from "./headertop.vue";
import AppMain from "./appmain.vue";
import { Loading } from "element-ui";
export default {
  components: { Sidebar, HeaderTop, AppMain,passwordInput},
  data() {
    return {
      dialogVisible:false,
      password:"",

    };
  },
  mounted() {},
  methods: {
     // 密码验证
   async passwordCheck(e) {
      let loadingInstance = Loading.service({
        text: "正在验证密码...",
        target: ".dialog-body"
      });
      try {
        await this.$http({
        url: "/api/zone/codeVerify",
        method: "POST",
        params: {
           zone_number: this.$cookies.get("zone_number"),
          code: e,
          code_type:"CODE_LOGOUT"
        },
        headers: {
          Token: this.$cookies.get("token")
        }
      });
       let _l = Loading.service({
        text: "退出中...",
        target: ".dialog-body"
      });
       let data = {
        zone_number: this.$cookies.get("zone_number")
      };
      this.$http({
        url: "/api/zone/logout",
        method: "POST",
        params: data,
        headers: {
          Token: this.$cookies.get("token")
        }
      }).then(res => {
        _l.close();
           let cookies = this.$cookies.keys();  // return a array;
      if(cookies && cookies.length > 0){
            for (const key of cookies) {
              this.$cookies.remove(key);
            }     
      }
       this.$router.push({ path: "/login" });
      });
      } catch (error) {
          this.password = ",,,,,";
          loadingInstance.close();
          return;
      }
    },
    logout(){
      this.dialogVisible = true;
    }
  },
};
</script>
<style  scoped>
.layout {
  width: 100%;
  display: flex;
  height: 100vh;
  background-color: #d5eaff;
}

.tip {
  /* height: 16px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #252b50;
  line-height: 16px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-top: 120px; */
  margin-bottom: 24px;
}

.dialog-body{
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

}

.layout_left {
  width: 300px;
  position: relative;
}
.layout_right {
  width: calc(100% - 300px);
  background-color: #fff;
  border-top-left-radius: 20px;
}
.header_top {
  height: 88px;
}
.app_main {
  height: calc(100% - 88px);
  overflow: auto;
}
.app_main::-webkit-scrollbar {
  width: 0px;
}
.logo_box {
  width: 100%;
  height: 88px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.logo_box img {
  width: 155px;
  margin-left: 40px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/view/layout/layout.vue